import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';
import { BaseCard } from '../styled';


export const Root = styled(BaseCard)`
  height: 304px;
`;

export const AvatarEnhancer = styled.div`
  > div {
    height: 84px;
    width: 84px;
  }
`;

export const AgentName = styled(H3)<{ isRegistered: boolean; verifiedIconColor: string; }>`
  ${({ theme, isRegistered, verifiedIconColor }) => `
    display: flex;
    align-items: center;
    color: ${isRegistered ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey3};
    white-space: nowrap;
    max-width: 100%;
    text-decoration: none;
    > span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    > svg {
      flex-shrink: 0;
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(0.5)};
      > path {
        fill: ${verifiedIconColor ? verifiedIconColor : theme.colors.brand.lighter};
      }
    }
  `}
`;

export const AgencyName = styled(Text)<{ isRegistered: boolean }>`
  ${({ theme, isRegistered }) => `
    color: ${isRegistered ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey3};
    white-space: nowrap;
    margin-top: ${theme.spacing(0.5)};
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;
